import { FormEvent } from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import * as actions from '../actions/'
import LoginForm, { Props } from '../components/LoginForm'
import { Model } from '../types/types'

export function mapStateToProps({ user }: Model): Pick<Props, 'user'> {
  return { user }
}

export function mapDispatchToProps(
  dispatch: Dispatch<actions.RootAction>,
): Pick<Props, 'onFormSubmit'> {
  return {
    onFormSubmit: (event: FormEvent<HTMLFormElement>): void => {
      event.preventDefault()
      const usernameInput = event.currentTarget.querySelector(
        '#username',
      ) as HTMLInputElement
      const passwordInput = event.currentTarget.querySelector(
        '#password',
      ) as HTMLInputElement

      if (
        !usernameInput ||
        !usernameInput.value ||
        !usernameInput ||
        !passwordInput.value
      ) {
        throw new Error(
          'Did not find elements with values; have you changed the login form html?',
        )
      }

      dispatch(
        actions.submitLoginForm(usernameInput.value, passwordInput.value),
      )
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LoginForm)
